<template>
    <div class="side_wishercardbg">
        <div :class="{side_eachcard: true, other: other_flag}" @click="clickcard" @mouseover="cursorover()" @mouseleave="cursorleave()">
            <div :class="{bigcircle:true, current:current_flag}">
                <div :class="{side_wisherimg: true, currentshadow: current_flag}">
                    <!-- <img :src="require(`@/assets/images/sidemenu/${site_name}.png`)" /> -->
                    <img :src="`https://p3.udn.com.tw/wish/images/side_menu/side_${site_name}.png`"/>
                </div>
            </div>
            <div class="side_wishername">
                {{name}}
            </div>
            <div class="side_wishertitle">
                <!-- {{title}} -->
                <div v-html="title.replace(' ','<br>')"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    export default {
        mixins: [sendGaMethods],
        props: {
            site_name: { type: String },
            name: { type: String },
            title: { type: String },
        },
        data(){
            return{
                other_flag:false,
                current_flag:false,
            }
        },
        components: {
        },
        mounted(){
            if(this.$store.state.currentwisher==this.site_name) this.current_flag=true;
        },
        methods:{
            clickcard(){
                this.sendGA({category: 'wisher bar pic', action: 'click', label: "click_wisher_bar_pic_"+this.site_name});
                    if(this.$store.state.currentwisher!=this.site_name){
                        window.open("https://udn70.udn.com/wish/"+this.site_name, '_blank');
                    }
            },
            cursorover(){
                if(this.$store.state.currentwisher!=this.site_name) this.other_flag=true;
            },
            cursorleave(){
                this.other_flag=false;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .side_wishercardbg{
        .side_eachcard{
            margin: 25px 5px 25px 5px;
            cursor: pointer;
            border-bottom: 1.5px solid transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            @media (min-width: 400px){
                margin: 25px 8.5px;
            }
            @media (min-width: 768px){
                margin: 25px;
            }
            .bigcircle{
                width: 75px;
                height: 75px;
                border-radius: 50%;
                background-color: transparent;
                @media (min-width: 768px) AND (max-width: 960px) {
                    width: 105px;
                    height: 105px;
                }
                @media (min-width: 960px) {
                    width: 110px;
                    height: 110px;
                }
                .side_wisherimg{
                    position: relative;
                    width: 67px;
                    height: 67px;
                    border-radius: 50%;
                    top: 2px;
                    left: 2px;
                    overflow: hidden;
                    box-shadow: 0px 0px 10px rgb(0, 0, 0, 0.2);
                    @media (min-width: 400px) AND (max-width: 768px) {
                        box-shadow: 0px 0px 30px rgb(0, 0, 0, 0.2);
                        width: 67px;
                        height: 67px;
                    }
                    @media (min-width: 768px) AND (max-width: 960px) {
                        width: 97px;
                        height: 97px;
                    }
                    @media (min-width: 960px) {
                        width: 102px;
                        height: 102px;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                        transition: .5s;
                    }
                }
                .currentshadow{
                    box-shadow: 0px 0px 30px rgb(160, 142, 51, 0.2);
                }
            }
            .current{
                border: 2px solid #A08E33;
            }
            
            .side_wishername{
                max-width: 75px;
                font-size: 15x;
                line-height: 21px;
                text-align:justify;
                margin-top: 12px;
                font-family: 'Noto Sans TC';
                font-weight: 300;
                color: #1D1C1B;
                @media (min-width: 768px) AND (max-width: 960px) {
                    margin-top: 20px;
                    max-width: 105px;
                }
                @media (min-width: 960px) {
                    margin-top: 20px;
                    max-width: 110px;
                }
            }
            .side_wishertitle{
                max-width: 75px;
                font-size: 15x;
                line-height: 21px;
                text-align: center;
                margin-top: 5px;
                opacity: 0.8;
                padding-bottom: 5px;
                font-family: 'Noto Sans TC';
                font-weight: 300;
                color: #999999;
                @media (min-width: 768px) AND (max-width: 960px) {
                    max-width: 105px;
                }
                @media (min-width: 960px) {
                    max-width: 110px;
                }
            }
        }
        .other{
            border-bottom: 1.5px solid #A08E33;
        }
        @media (hover: hover) {
            .side_eachcard:hover img{
                @media (min-width: 960px) {
                    transform: scale(1.2);
                }
            }
        }
    }
</style>